import { Observable } from 'rxjs';
import { TableColumn, IdentifierTableColumn, RadioComponent, SelectDialogComponent } from '@serengeti/serengeti-common';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

export class VariableBrowser {
    public dialog: MatDialog;

    public constructor(dialog: MatDialog) {
        this.dialog = dialog;
    }

	public browse(title?: string): Observable<any> {
		const dialogRef = this.dialog.open(SelectDialogComponent, {
			width: '1300px',
			height: '900px',
			data: {
				title: (title ? title : 'setting.task.schedule.variable.dialog.select-variable.title'),
				query: environment.serviceSchedulerEndPoint + '/task/variable/',
				method: 'page',
				columns: [
					new IdentifierTableColumn('id', 'setting.task.schedule.variable.dialog.select-variable.columns.id', false).withType(RadioComponent),
					new TableColumn('name', 'setting.task.schedule.variable.dialog.select-variable.columns.name')
					.withStyles('text-15'),
					new TableColumn('variableName', 'setting.task.schedule.variable.dialog.select-variable.columns.variable-name'),
					new TableColumn('variableType', 'setting.task.schedule.variable.dialog.select-variable.columns.variable-type'),
					new TableColumn('apiName', 'setting.task.schedule.variable.dialog.select-variable.columns.api-name'),
					new TableColumn('apiUrl', 'setting.task.schedule.variable.dialog.select-variable.columns.api-url')
					.withStyles('text-20')
				]
			}
    	});
    
		return dialogRef.afterClosed();
	}
}
